var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _lexer, _out, _lexedToken;
import { Lexer, Token } from "./lexer";
export class Parser {
    constructor(input) {
        _lexer.set(this, void 0);
        _out.set(this, { patterns: [] });
        _lexedToken.set(this, void 0);
        __classPrivateFieldSet(this, _lexer, new Lexer(input));
    }
    undoToken(t) {
        if (__classPrivateFieldGet(this, _lexedToken)) {
            throw new Error("fatal error while parsing");
        }
        __classPrivateFieldSet(this, _lexedToken, t);
    }
    nextToken() {
        if (__classPrivateFieldGet(this, _lexedToken)) {
            const t = __classPrivateFieldGet(this, _lexedToken);
            __classPrivateFieldSet(this, _lexedToken, undefined);
            return t;
        }
        return __classPrivateFieldGet(this, _lexer).nextToken();
    }
    parse() {
        let t = this.nextToken();
        if (t.token === Token.PassingOpen) {
            this.parsePatterns(true);
        }
        else {
            this.undoToken(t);
            __classPrivateFieldGet(this, _out).patterns.push(this.parsePattern(false));
        }
        t = this.nextToken();
        if (t.token !== Token.EOF) {
            throw new Error("end of pattern expected");
        }
        return __classPrivateFieldGet(this, _out);
    }
    parsePatterns(passing) {
        while (true) {
            const p = this.parsePattern(passing);
            __classPrivateFieldGet(this, _out).patterns.push(p);
            const t = this.nextToken();
            if (t.token === Token.PassingSep) {
                continue;
            }
            else if (t.token === Token.PassingClose) {
                break;
            }
            else {
                throw new Error("passing pattern: '|' or '>' expected");
            }
        }
    }
    syncRepeatSwap(throws) {
        const swappedThrows = [...throws];
        swappedThrows.reverse();
        return swappedThrows;
    }
    parseSync(passing) {
        const throws = [];
        do {
            throws.push(this.parseMultiplexThrow(passing, true));
            const t = this.nextToken();
            if (t.token === Token.SyncClose) {
                break;
            }
            else if (t.token === Token.SyncSep) {
                continue;
            }
            else {
                throw new Error("synchronous ',' or ')' expected");
            }
        } while (true);
        const beats = [
            {
                beatThrows: throws,
            },
        ];
        const nt = this.nextToken();
        if (nt.token === Token.SyncRepeatSwap) {
            beats.push({
                beatThrows: this.syncRepeatSwap(throws),
            });
        }
        else {
            this.undoToken(nt);
        }
        return beats;
    }
    parsePattern(passing) {
        const p = { beats: [] };
        while (true) {
            let t = this.nextToken();
            if (t.token === Token.SyncOpen) {
                const syncBeats = this.parseSync(passing);
                p.beats = p.beats.concat(syncBeats);
            }
            else {
                this.undoToken(t);
                const tr = this.tryParseMultiplexThrow(passing, false);
                if (tr) {
                    p.beats.push({ beatThrows: [tr] });
                }
                else {
                    break;
                }
            }
        }
        if (!p.beats.length) {
            throw new Error("invalid empty pattern");
        }
        return p;
    }
    parseMultiplexThrow(passing, sync) {
        const t = this.tryParseMultiplexThrow(passing, sync);
        if (!t) {
            throw new Error("throw or multiplex expected");
        }
        return t;
    }
    tryParseMultiplexThrow(passing, sync) {
        const ret = { multiplexes: [] };
        let t = this.nextToken();
        if (t.token === Token.MultiplexOpen) {
            while (true) {
                t = this.nextToken();
                if (t.token === Token.Number) {
                    this.undoToken(t);
                    ret.multiplexes.push(this.parseThrow(passing, sync));
                }
                else if (t.token === Token.MultiplexClose) {
                    break;
                }
                else {
                    throw new Error("throw or multiplex close expected");
                }
            }
            return ret;
        }
        else if (t.token === Token.Number) {
            this.undoToken(t);
            ret.multiplexes.push(this.parseThrow(passing, sync));
            return ret;
        }
        else {
            this.undoToken(t);
            return;
        }
    }
    parseThrow(passing, sync) {
        const t = this.nextToken();
        if (t.token !== Token.Number) {
            throw new Error("throw expected");
        }
        const ret = {
            height: t.value,
            cross: false,
            pass: false,
        };
        if (sync) {
            ret.cross = this.tryParseCrossModifier();
        }
        if (passing) {
            const [pass, passTo] = this.tryParsePassingModifier();
            ret.pass = pass;
            if (typeof passTo !== "undefined") {
                ret.passTo = passTo;
            }
        }
        return ret;
    }
    tryParseCrossModifier() {
        const t = this.nextToken();
        const charX = 33; // 'x'
        const cross = t.token === Token.Number && !t.leadingWS && t.value === charX;
        if (!cross) {
            this.undoToken(t);
        }
        return cross;
    }
    tryParsePassingModifier() {
        let pass = false;
        let passTo = undefined;
        const t = this.nextToken();
        const charP = 25; // 'p'
        if (t.token === Token.Number && !t.leadingWS) {
            const height = t.value;
            if (height === charP) {
                pass = true;
                const nt = this.nextToken();
                if (nt.token === Token.Number && !nt.leadingWS) {
                    passTo = nt.value - 1;
                }
                else {
                    this.undoToken(nt);
                }
            }
        }
        if (!pass) {
            this.undoToken(t);
        }
        return [pass, passTo];
    }
}
_lexer = new WeakMap(), _out = new WeakMap(), _lexedToken = new WeakMap();
